import React, { useState } from 'react';
import {
  MessageCircle,
  Users,
  Handshake,
  ChevronDown,
  LogIn,
  HelpCircle,
  Clock,
  Globe,
  Calendar,
  PlayCircle,
  CheckCircle,
  Mail,
  FileText,
  Star
} from 'lucide-react';
import { FaLaptopCode, FaUtensils, FaBuilding, FaSubway, FaGlobe, FaTrain } from "react-icons/fa";

import './ContactPage.css';
import { useNavigate } from 'react-router-dom';
import HRCopilotFAQ from './HRCopilotFAQ';
import ContactFormSection from './ContactFormSection';
import HumanexFAQ from './HumanexFAQ';



const ContactPage = () => {
  const [activeTab, setActiveTab] = useState('support');
  const [hoverTab, setHoverTab] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();


  const handleAccessRecruit = () => navigate('/access-recruit');


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission (replace with actual API call)
    try {
      await new Promise(resolve => setTimeout(resolve, 1000)); // Simulate API call

      // Show success message
      setShowSuccess(true);

      // Reset form
      e.target.reset();

      // Hide success message after 5 seconds
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);

    } catch (error) {
      console.error('Form submission error:', error);
      alert('There was an error submitting the form. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      question: "Which HRIS systems does HRCopilot integrate with?",
      answer: "HRCopilot seamlessly integrates with major HRIS platforms including Workday, BambooHR, ADP, SAP SuccessFactors, Oracle HCM, and many more through our robust API connections."
    },
    {
      question: "How secure is HRCopilot?",
      answer: "HRCopilot employs enterprise-grade security with end-to-end encryption, SOC 2 Type II compliance, GDPR adherence, and regular security audits to protect your sensitive HR data."
    },
    {
      question: "How customizable is HRCopilot?",
      answer: "HRCopilot is highly customizable with configurable workflows, custom fields, branded portals, role-based permissions, and flexible reporting to match your organization's unique needs."
    }
  ];

  return (
    <div className="hrcopilot-contact-container">
      {/* Header Section */}
      <ContactFormSection />
      <HumanexFAQ />

      {/* Global Offices Section */}
      <section className="office-locations">
        <h2>
          Our <span>Global</span> Presence
        </h2>
        <p>
          Join our team working across continents in state-of-the-art offices designed
          for innovation and collaboration.
        </p>

        <div className="office-grid">
          {[
            {
              city: "LONDON",
              badge: "HQ",
              flag: "uk",
              image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=1170&q=80",
              address1: "128 City Road,",
              address2: "London, EC1V NX",
              country: "UNITED KINGDOM",
              features: [{ icon: <FaGlobe />, text: "Central Business District" },{ icon: <FaTrain />, text: "Tube Access" }]
            },
            {
              city: "TENNESSEE",
              badge: "Americas",
              flag: "🇺🇸",
              image: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=1244&q=80",
              address1: "522 Aventura Dr, Mt Juliet,",
              address2: "Tennessee 37122",
              country: "UNITED STATES",
              features: [{ icon: <FaBuilding />, text: "Manhattan Views" },{ icon: <FaSubway />, text: "Subway Connected" }]
            },
            {
              city: "BANGALURU",
              badge: "Tech Hub",
              flag: "🇮🇳",
              image: "https://images.unsplash.com/photo-1698332137428-3c4296198e8f?auto=format&fit=crop&w=700&q=60",
              address1: "VO-173, Embassy Golf Links Business Park,",
              address2: "Bengaluru, Karnataka",
              country: "INDIA",
              features: [{ icon: <FaLaptopCode />, text: "Innovation Center" },{ icon: <FaUtensils />, text: "Campus Dining" }]
            }
          ].map((office, index) => (
            <div className="office-card" key={index}>
              <div className="office-image">
                <img src={office.image} alt={`${office.city} office`} />
                <div className="office-flag">{office.flag}</div>
              </div>

              <div className="office-content">
                <div className="office-header">
                  <h3>{office.city}</h3>
                  <span className="office-badge">{office.badge}</span>
                </div>

                <address>
                  <strong>{office.address1}</strong>
                  <br />
                  {office.address2}
                  <br />
                  {office.country}
                </address>

                <div className="office-features">
                  {office.features.map((feature, i) => (
                    <span className="feature" key={i}>
                      <span className="feature-icon">{feature.icon}</span>
                      <span className="feature-text">{feature.text}</span>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>


      {/* Contact Form Section */}

    </div>
  );
};

export default ContactPage;